/* The bundle book (Luka 2026-10-06, with D1's Remove confirm, ~/.bb-canary/bb-remove-prompt): this device's record of
   EVERY bundle it added to the cart, so the cart's Remove on a wheel can name exactly the parts that came with that wheel,
   even with two or more bundles in the cart, instead of asking "Which one should go with it?".

   One localStorage key, gsi.bundles.v1 = { token, bundles: [{ id, at, wheel, owned: { variantId: units } }] }:
   - the builder (assets/bundle-builder.js) adds an entry on every Add (the units that Add put in, the same as #84's
     ledger for the build in hand) and keeps it in step with Update your cart; Start another or a new Add never drop it;
   - every cart read reconciles it (the builder's reads, the guard's page data): another cart (a new token, after a
     checkout) empties it; per variant, the recorded units never exceed what the cart's plain lines hold, the newest
     bundles giving units up first; a bundle with nothing of it left leaves.
   A hint for the question only, never entitlement: the discount and the validation read collections (plan §3.1), so a
   stale or forged book can neither grant nor block anything. Per device and per browser: a bundle added elsewhere is not
   in it, and the cart guard then asks, as before. */
(() => {
  'use strict';
  if (window.GSIBundleBook) return;
  const KEY = 'gsi.bundles.v1';
  const tokenOf = (t) => String(t || '').split('?')[0];
  const empty = () => ({ token: '', bundles: [] });
  function read() {
    try {
      const b = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (b && Array.isArray(b.bundles)) return b;
    } catch (e) { /* no storage, or not ours */ }
    return empty();
  }
  function write(b) {
    try {
      if (!b.bundles.length) localStorage.removeItem(KEY);
      else localStorage.setItem(KEY, JSON.stringify(b));
    } catch (e) { /* private mode: the guard asks, as before */ }
  }
  const clean = (owned) => {
    const out = {};
    for (const [v, q] of Object.entries(owned || {})) if ((Number(q) || 0) > 0) out[String(v)] = Number(q);
    return out;
  };
  /** A bundle the builder just added: its id, its wheel's variant (owned or borrowed from the cart), the units it sent. */
  function add({ id, wheel, owned }) {
    if (!id) return;
    const b = read();
    b.bundles = b.bundles.filter((x) => x.id !== id);
    b.bundles.push({ id, at: Date.now(), wheel: String(wheel || ''), owned: clean(owned) });
    write(b);
  }
  /** The builder's Update your cart moved units: the entry follows its ledger (a bundle added before the book, by its
   *  build still in hand, joins it here). */
  function update(id, owned, wheel) {
    const b = read();
    const x = b.bundles.find((e) => e.id === id);
    if (!x) { add({ id, wheel, owned }); return; }
    x.owned = clean(owned);
    if (wheel) x.wheel = String(wheel);
    write(b);
  }
  /**
   * In step with a cart just read: { token, items: [{ variantId, quantity, plain }] } (plain: a line with no properties;
   * the builder adds plain lines, and a line with properties, a Custom wheel, never holds a bundle's units). Returns it.
   */
  function reconcile(cart) {
    const b = read();
    if (!b.bundles.length || !cart || !Array.isArray(cart.items)) return b;
    const t = tokenOf(cart.token);
    if (t && b.token && t !== b.token) { write(empty()); return empty(); }
    if (t && !b.token) b.token = t;
    const avail = new Map();
    for (const i of cart.items) {
      if (i.plain === false) continue;
      const v = String(i.variantId);
      avail.set(v, (avail.get(v) || 0) + (Number(i.quantity) || 0));
    }
    // the oldest bundles keep their units, the newest give them up first (what a drawer change took most likely came
    // off the bundle in hand)
    const used = new Map();
    for (const x of b.bundles) {
      for (const [v, q] of Object.entries(x.owned)) {
        const keep = Math.max(0, Math.min(Number(q) || 0, (avail.get(v) || 0) - (used.get(v) || 0)));
        if (keep) { x.owned[v] = keep; used.set(v, (used.get(v) || 0) + keep); } else delete x.owned[v];
      }
    }
    b.bundles = b.bundles.filter((x) => Object.keys(x.owned).length || (avail.get(x.wheel) || 0) > 0);
    write(b);
    return b;
  }
  /**
   * Q1 F-1 (2026-10-08): the wheel units this device's bundles hold, by variant: a bundle still in the cart (a part of it
   * besides its wheel left) keeps its wheel, owned or borrowed, so that wheel isn't a loose one. `except`: a bundle id to
   * leave out (the build in hand). A bundle whose parts all left no longer claims its wheel.
   */
  function bundleWheels(except) {
    const out = new Map();
    for (const x of read().bundles) {
      if (!x.wheel || x.id === except) continue;
      if (!Object.keys(x.owned || {}).some((v) => v !== x.wheel)) continue;
      out.set(x.wheel, (out.get(x.wheel) || 0) + 1);
    }
    return out;
  }
  window.GSIBundleBook = { KEY, read, add, update, reconcile, tokenOf, bundleWheels };
})();
